<template lang='pug'>
el-container.main
    .main-header
        .main-breadcrumb
            span.bcb 组织信息
        .main-action
            el-button(type="primary", size="small", :disabled="orgCreateDisable", @click="handleCreateOrgClick") 创建

    .main-content(v-if="!orgCreateDisable")
        .block
            span 您尚未创建组织
    .main-content(v-else)
        .block
            el-form(:model="org")
                el-form-item(label="组织代号", label-position="top")
                    el-input(v-model="org.name", disabled)
                el-form-item(label="展示名", label-position="top")
                    el-input(v-model="org.displayName")
                el-form-item(label="邮箱", label-position="top")
                    el-input(v-model="org.email")
                el-form-item(label="描述", label-position="top")
                    el-input(type="textarea", v-model="org.description")
                el-form-item
                    el-button(type="success", size="small", @click="updateOrg") 更新资料
        .block
            span 成员数: {{ org.memberCount }}
            span 团队数: {{ org.teamCount }}

    el-dialog(title="创建组织", :visible.sync="orgCreateDialogFormVisible")
        el-form(:model="orgCreateForm")
            el-form-item(label="代号", label-width="80px")
                el-input(v-model="orgCreateForm.name")
            el-form-item(label="名称", label-width="80px")
                el-input(v-model="orgCreateForm.displayName")
            el-form-item(label="邮箱", label-width="80px")
                el-input(v-model="orgCreateForm.email")
        .dialog-footer(slot="footer")
            el-button(@click="handleOrgCreateCancelClick") 取 消
            el-button(type="primary", @click="handleOrgCreateConfirmClick") 确 定
</template>

<script>
// @ is an alias to /src
import { getUserOrgsAPI, createOrgAPI, updateOrgAPI } from '@/services'

export default {
  name: 'Organization',
  data() {
    return {
      loading: false,
      page: {
        total: 1,
        number: 1
      },
      org: {},
      orgCreateDisable: false,
      orgCreateDialogFormVisible: false,
      orgCreateForm: {
        name: '',
        displayName: '',
        email: ''
      }
    }
  },
  watch: {},
  methods: {
    async getUserOrgs() {
      this.loading = true
      try {
        const res = await getUserOrgsAPI({
          name: localStorage.getItem('account')
        })
        if (res.status === 200 && res.data.length) {
          this.orgCreateDisable = !!res.data.length
          this.org = Object.assign({}, res.data[0].org)
          this.org['memberCount'] = res.data[0].memberCount
          this.org['teamCount'] = res.data[0].teamCount
        }
      } catch (err) {
        console.log(localStorage.getItem('account'))
        this.$message.error('获取信息失败，请尝试刷新或重新登录')
      } finally {
        this.loading = false
      }
    },
    async createOrg() {
      try {
        const res = await createOrgAPI(
          this._.pickBy(this.orgCreateForm, this._.identity)
        )
        if (res.status === 201) {
          this.getUserOrgs()
        } else {
          throw err
        }
      } catch (err) {
        this.$message.error('服务器开小差了，请尝试重新操作')
      }
    },
    async updateOrg() {
      try {
        const res = await updateOrgAPI(
          this._.pickBy(this.org, this._.identity)
        )
        if (res.status === 200) {
          this.$message.success('更新成功')
        } else {
          throw err
        }
      } catch (err) {
        console.log(err)
        this.$message.error('服务器开小差了，请尝试重新操作')
      }
    },
    handleCreateOrgClick() {
      this.orgCreateDialogFormVisible = true
    },
    handleOrgCreateCancelClick() {
      this.orgCreateDialogFormVisible = false
    },
    handleOrgCreateConfirmClick() {
      this.orgCreateDialogFormVisible = false
      this.createOrg()
    },
    /**
         * Table Event Method
         */
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #f2f2f2;color: #8493A8;'
      }
    },
    dateFormat(row, column) {
      const date = row[column.property]
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  mounted() {
    this.getUserOrgs()
  }
}
</script>
<style lang="stylus" scoped>
.block {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 10px;
  padding: 20px;
  border: dashed 1px #bbbbbb;
  border-radius: 15px;

  span {
    margin: auto;
  }

  .el-input {
    width: 360px;
  }
}
</style>
